module.exports = __webpack_public_path__ + "img/humidity.6224c878.svg";